import { PAMUserApi } from './../../config/api-url';
import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { dashboardApi } from '../../config';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {

  constructor(private apiService: ApiService) { }

  getSellerDashboardFull(userId) {
    return this.apiService.get(`${dashboardApi.getSellerDashboardFull}${userId}`);
  }

  getManagerDashboardFull(compId,userID) {
  
   
    return this.apiService.get(`${dashboardApi.getManagerDashboardFull}${userID}?companyId=${compId}`);
  }

  getNotifications(params) {
    return this.apiService.get(`${dashboardApi.getNotifications}`, params);
  }

  postDeleteNotification(body) {
    return this.apiService.post(`${dashboardApi.postDeleteNotification}`, body);
  }

  getSellerChallenges(userId, params) {
    return this.apiService.get(`${dashboardApi.getSellerChallenges}${userId}`, params);
  }

  getManagerActivationChallenges(userId) {
    return this.apiService.get(`${dashboardApi.getManagerActivationChallenges}${userId}`);
  }

  postBudgetStatsCaps(params) {
    return this.apiService.post(`${dashboardApi.postBudgetStatsCaps}?companyId=${params.companyId}&userId=${params.userId}&quarterOption=${params.quarterOption}`);
  }

  updateNotification(body) {
    return this.apiService.post(`${dashboardApi.updateNotification}`, body);
  }

  getNotificationsCount() {
    return this.apiService.get(`${dashboardApi.getNotificationsCount}`);
  }
  getRegionList(userId){
    return this.apiService.get(`${PAMUserApi.getTheatersRequest}${userId}`);
  }
  getCountryListRequest(userId,region){
    return this.apiService.get(`${PAMUserApi.getCountryGroupsRequest}${userId}?theater=${region}`);
  }
  getBeGeoIdsRequest(paramReq){
    return this.apiService.post(`${PAMUserApi.getBeGeoIdsRequest}`,paramReq)
  }
  getQuarterList(){
    return this.apiService.get(`${dashboardApi.quarterList}`);
  }
}
